// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"aef300f1","122":"c810a9e3","307":"9a174762","320":"c256cb5e","458":"0509354a","591":"6b0a61c3","774":"71eb4682","787":"2e95b2b3","819":"ee45c3b3","851":"ff696cd8"}[chunkId] + ".chunk.js";
};